module.exports = __webpack_public_path__ + "media/images/ui__textArrowRightLight-e780dcfe0fcc7c0d182e2782180d330e.png";